// Sales-target-api
export const salesTargetListApi = 'sales-distribution-admin/sales-target/list'
export const salesTargetStoreApi = 'sales-distribution-admin/sales-target/store'
export const salesTargetUpdateApi = 'sales-distribution-admin/sales-target/update'
export const salesForwardUpdateApi = 'sales-distribution-admin/sales-target/forward-update'
export const salesTargetToggleStatusApi = 'sales-distribution-admin/sales-target/toggle-status'
export const salesTargetById = 'sales-distribution-admin/sales-target/sales-target-data'
export const userListApi = 'user/get-all-users'
export const userListByDesignationApi = 'user/users-by-designation-id'
// Sales-target-request-api
export const salesRequestListApi = 'sales-distribution-admin/sales-target-request/list'
export const salesRequestForwardUpdateApi = 'sales-distribution-admin/sales-target-request/forward-update'
export const salesTargetRequestUpdateApi = 'sales-distribution-admin/sales-target-request/update'
export const salesTargetRequestStatusUpdateApi = 'sales-distribution-admin/sales-target-request/update-status'
// Sales-target-approve-list-api
export const salesRequestApproveListApi = 'sales-distribution-admin/sales-target-approve-list/list'
// Demand-order-view
export const demandOrderListApi = 'sales-distribution-admin/demand-order-view/list'
export const demandOrderById = 'sales-center/demand-order-entry/demand-order-data'
export const availableStockInfo = 'sales-distribution-admin/demand-order-view/availableStockInfo'

// Delivery-Order-Entry
export const deliveryOrderEntryApi = 'sales-distribution-admin/delivery-order-entry/store'
export const deliveryListApi = 'sales-distribution-admin/delivery-order-entry/list'

// Delivery-Order-Receive
export const deliveryOrderReceiveListApi = 'sales-distribution-admin/delivery-order-receive/list'
export const deliveryOrderReceiveStoreApi = 'sales-distribution-admin/delivery-order-receive/store'

export const fiscalYearData = 'master-fiscal-year/show'
// Delivery-Report-Api
export const deliveryOrderReportApi = 'sales-distribution-admin/delivery-order-report/list'

// free-product-report-Api
export const freeProductReportApi = 'sales-distribution-admin/free-product-report/list'

// Monthly Sales Report
export const monthlySalesReportApi = 'sales-distribution-admin/monthly-sales-report/list'
// Demand-Order-Report-Api
export const demandOrderReportApi = 'sales-distribution-admin/demand-order-report/list'
// Due Collection Report Api
export const dueCollectionReportList = 'sales-distribution-admin/due-collection-report/list'
// Dealer-reailer Ledger Report Api
export const ledgerReportListApi = 'sales-distribution-admin/dealer-retailer-ledger-report/list'
// Dealer-reailer Details Report Api
export const dealerRetailerDetailsReportApi = 'sales-distribution-admin/dealer-retailer-details-report/list'

// delivery order receive payment
export const deliveryRecPay = '/dealer-retailer-management/delivery-order-payment'
export const deliveryRecPayList = deliveryRecPay + '/get-order-list-admin'
export const Paymentlist = deliveryRecPay + '/list'
export const PaymentShow = deliveryRecPay + '/show'

export const otherOrderPaymentEntry = deliveryRecPay + '/other-payment-admin'
export const checkOrderPaymentEntry = deliveryRecPay + '/check-admin'
export const cashOrderPaymentEntry = deliveryRecPay + '/cash-admin'

export const editOtherOrderPaymentEntry = deliveryRecPay + '/other-payment-admin-edit'
export const editCheckOrderPaymentEntry = deliveryRecPay + '/check-admin-edit'
export const editCashOrderPaymentEntry = deliveryRecPay + '/cash-admin-edit'

export const checkPaymentVerify = deliveryRecPay + '/verify'
export const offlineOrderPaymentEntry = deliveryRecPay + '/offline-admin'
export const offlinePaymentVerify = deliveryRecPay + '/verify'

// Sales Center Stock Report
export const scstockReportApi = 'sales-distribution-admin/stock-report/list'

// Dashboard Routes
export const scsalesReportApi = 'sales-distribution-admin/dashboard/sales-report'
export const scorderReportApi = 'sales-distribution-admin/dashboard/order-report'

// Product Return Report apis
export const productReturnReportApi = 'sales-distribution-admin/product-return-report/list'

// Return Product Routes
export const returnProductListApi = 'sales-distribution-admin/return-product/list'
export const returnProductStoreApi = 'sales-distribution-admin/return-product/store'

// delivery order return and adjust apis
export const adjustDeliveryOrderListApi = 'sales-distribution-admin/delivery-order-adjust/list'
export const adjustDeliveryOrderStoreApi = 'sales-distribution-admin/delivery-order-adjust/store'
export const adjustDeliveryOrderUpdateApi = 'sales-distribution-admin/delivery-order-adjust/update'
export const singleUserDeliveryOrderApi = 'sales-distribution-admin/delivery-order-adjust/get-delivery'

// sales register report route
export const salesRegisterReport = 'sales-distribution-admin/sales-register/list'

// sales report report route
export const salesReport = 'sales-distribution-admin/sales-report/list'
